;(function ($) {
    'use strict'

    const { __, _x, _n, _nx } = wp.i18n || {}

    const $body = $('body')

    const breakpoints = {
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1400,
    }

    const mediaBreakpointDown = (size) =>
        window.matchMedia(`(max-width: ${size - 0.02}px)`).matches

    const mediaBreakpointUp = (size) =>
        window.matchMedia(`(min-width: ${size}px)`).matches

    const isPageTemplate = (templateName) =>
        document.body.classList.contains(`page-template-${templateName}`)

    const isPageId = (pageId) =>
        document.body.classList.contains(`page-id-${pageId}`)

    // DOM ready
    $(function () {
        // Switch to the tab specified in the URL hash
        if (isPageTemplate('multiple-tabs-page')) {
            monitorHashChanges()
        }

        /** Init Wow.js animations **/
        const wow = new WOW({
            animateClass: 'animate__animated',
            offset: 50,
        })
        wow.init()

        const timelines = document.querySelectorAll('.timeline')
        if (timelines.length > 0) {
            gsap.registerPlugin(ScrollTrigger)

            // Refresh ScrollTrigger on tab change
            document
                .getElementById('history-tab')
                ?.addEventListener('shown.bs.tab', (event) => {
                    document
                        .querySelectorAll('.timeline-tracker')
                        .forEach((tt) => {
                            tt.style.top = '0%'
                        })
                    ScrollTrigger.refresh()
                })
        }
        timelines.forEach(setupTimeline)

        // Set up Slick slider for latest publications on homepage
        const $publicationsSlider = $('.publications-list.slider')
        if ($publicationsSlider.length) {
            $publicationsSlider.slick({
                slidesToShow: 1,
                fade: true,
                dots: true,
                adaptiveHeight: true,
            })
        }

        // Handle tab show event
        const pageTabs = document.querySelectorAll(
            '#pageTab [data-bs-toggle="tab"]'
        )
        pageTabs.forEach((tab) => {
            tab.addEventListener('show.bs.tab', handleTabShow)
            tab.addEventListener('shown.bs.tab', handleTabShown)
        })

        const studyViewsTabs = document.querySelectorAll(
            '#studiesViewsTab [data-bs-toggle="tab"]'
        )
        studyViewsTabs.forEach((tab) => {
            tab.addEventListener('show.bs.tab', handleStudyViewsTabShow)
        })

        // Handle offcanvas toggle
        const $navbarNavOffcanvas = $('#navbarNavOffcanvas')
        $navbarNavOffcanvas.on(
            'show.bs.offcanvas hide.bs.offcanvas',
            handleOffcanvasToggle
        )

        /** Set up AJAX archive filters **/
        const archiveFilters = document.querySelectorAll(
            '.archive-filters--ajax'
        )
        archiveFilters.forEach(setupArchiveFilters)

        // Initialize Bootstrap tooltips
        $('[data-bs-toggle="tooltip"]').tooltip()

        // Set up copy to clipboard buttons
        const copyButtons = document.querySelectorAll('.copy-to-clipboard')
        copyButtons.forEach(setupCopyToClipboardButton)

        // A11y fix for Ultimate Member toggle password button
        const umTogglePasswordButtons = document.querySelectorAll(
            '.um-toggle-password'
        )
        umTogglePasswordButtons.forEach(setupUMTogglePasswordButtonA11y)

        if (!isPageId(1004) && !isPageId(1491)) {
            setupStickyHeader()
        }

        // Toggle the disabled state of WPForms conditional fields
        $(document).on(
            'wpformsProcessConditionalsField',
            toggleWPFormsDisabledFields
        )

        // Set default value for select fields inside conditional repeaters
        $(document).on(
            'wpformsProcessConditionalsField',
            setDefaultSelectValueFollowupField
        )

        // Replace WPForms placeholders with the actual field
        document
            .querySelectorAll('.wpforms-placeholder')
            .forEach(replaceWPFormsPlaceholders)

        // Fix WPForms repeater fields positioning inside layouts
        $(document).on(
            'wpformsRepeaterFieldCloneCreated',
            fixWPFormsRepeaterPositioning
        )

        // Update placeholder dynamically for each repeater row
        $(document).on(
            'wpformsRepeaterFieldCloneCreated wpformsRepeaterFieldCloneRemoved',
            updateDynamicNumberPlaceholder
        )

        // Update label dynamically for each timepoint row
        $(document).on(
            'wpformsRepeaterFieldCloneCreated wpformsRepeaterFieldCloneRemoved',
            updateDynamicTimepointLabel
        )

        // Setup button to add new funders or select existing ones
        setupFunderButtons()

        // Setup custom buttons to add new rows to repeater fields
        setupAddRowButton()

        // Move the save draft button to the left panel of the CDR form
        repositionSaveDraftButton(
            document.querySelector('.wpforms-save-resume-button')
        )

        // Prevent accidental form exit by showing a confirmation dialog
        preventAccidentalFormExit()

        // Initialize WPForms select2 fields
        initializeWPFormsSelect2Fields(
            document.querySelectorAll('.wpforms-form .select2 select')
        )

        // Initialize WPForms taxonomy tag cloud functionality
        initializeWPFormsTaxonomyTagCloud()

        // Initialize WPForms synced fields
        initializeWPFormsSyncedFields(document.querySelectorAll('.wpf-sync'))

        // Set minimum/maximum attributes for WPForms number fields
        setMinMaxAttributesForWPFormsNumberFields()

        // Make sure there is at least 1 row in the follow-up repeater field
        $(document).on('wpformsReady', initializeFollowupRepeaterField)

        // By default, conditional tags should be disabled
        $(document).on('wpformsReady', initializeConditionalTags)

        // Make sure end date is always greater than start date
        $(document).on('wpformsReady', () => {
            validateDatepickerRange(
                document.getElementById('wpforms-1009-field_44'),
                document.getElementById('wpforms-1009-field_45')
            )
        })

        /*** FacetWP setup ***/
        if ('undefined' !== typeof FWP && 'undefined' !== typeof FWP.hooks) {
            // Exclude some facets from flyout
            FWP.hooks.addFilter('facetwp/flyout/facets', excludeFlyoutFacets)

            // Modify each facet's wrapper HTML
            FWP.hooks.addFilter(
                'facetwp/flyout/facet_html',
                filterFlyoutFacetHTML
            )

            // Set the default map position
            document.addEventListener('facetwp-refresh', setDefaultMapPosition)

            // Initialze or update map data after every facetwp interaction
            document.addEventListener(
                'facetwp-loaded',
                initializeOrUpdateMapData
            )

            document.addEventListener('facetwp-loaded', cacheStudyResultsCount)
            document.addEventListener('facetwp-loaded', updateSitesList)
            document.addEventListener(
                'ccb-sites-list-updated',
                updateSitesResultsCount
            )

            document
                .getElementById('studiesViewsTab')
                ?.addEventListener(
                    'shown.bs.tab',
                    updateResultsCountForActiveView
                )
        }
    }) // End DOM ready

    /**
     * Set up GSAP timelines
     *
     * @param {HTMLElement} timeline
     */
    function setupTimeline(timeline) {
        const timelineTracker = timeline.querySelector('.timeline-tracker')

        if (timelineTracker) {
            // Track timeline progress
            ScrollTrigger.create({
                trigger: timeline,
                start: 'top center',
                end: 'bottom center',
                onUpdate: (self) => {
                    gsap.to(timelineTracker, {
                        top: () => `${self.progress * 100}%`,
                    })
                },
            })

            timeline.querySelectorAll('.event__date').forEach((year) => {
                ScrollTrigger.create({
                    trigger: year,
                    start: 'top center',
                    end: '+=16',
                    onEnter: (self) => {
                        year.classList.add('passed')
                        timelineTracker.classList.add('passing')
                    },
                    onLeave: (self) => {
                        timelineTracker.classList.remove('passing')
                    },
                    onEnterBack: (self) => {
                        timelineTracker.classList.add('passing')
                    },
                    onLeaveBack: (self) => {
                        year.classList.remove('passed')
                        timelineTracker.classList.remove('passing')
                    },
                })
            })
        }
    }

    /**
     * Set up classes for sticky headers
     *
     */
    function setupStickyHeader() {
        const fixedClass = 'is-sticky'
        const fixedTransitionClass = 'stickying'
        const mainNav = document.getElementById('main-nav')
        const wrapper = document.getElementById('wrapper-navbar')
        const transitionDuration = 500

        if (!mainNav) {
            return
        }

        let threshold = mainNav.offsetHeight / wrapper.offsetHeight
        if (!isFinite(threshold)) {
            threshold = 1
        }

        const callback = function (entries) {
            entries.forEach((entry) => {
                if (entry.intersectionRatio >= threshold) {
                    if (
                        !mainNav.classList.contains(fixedTransitionClass) &&
                        mainNav.classList.contains(fixedClass)
                    ) {
                        mainNav.classList.add(fixedTransitionClass)
                        mainNav.classList.remove(fixedClass)

                        setTimeout(() => {
                            mainNav.classList.remove(fixedTransitionClass)
                        }, transitionDuration)
                    }
                } else {
                    if (
                        !mainNav.classList.contains(fixedTransitionClass) &&
                        !mainNav.classList.contains(fixedClass)
                    ) {
                        mainNav.classList.add(fixedClass)
                        mainNav.classList.add(fixedTransitionClass)

                        setTimeout(() => {
                            mainNav.classList.remove(fixedTransitionClass)
                        }, transitionDuration)
                    }
                }
            })
        }
        const observer = new IntersectionObserver(callback, {
            threshold: [...new Set([0, 0.5, 1, threshold])], // Filter out duplicates
        })

        observer.observe(wrapper)
    }

    /**
     * Switch to the given Bootstrap Tab
     * @param {string} tabId - The tab ID
     */
    function switchToTab(tabId) {
        const $tab = $(`#${tabId}`)
        $tab.tab('show')
    }

    /**
     * Handle the page tab show
     *
     * @param {Event} event - The Bootstrap Tab event
     */
    function handleTabShow(event) {
        const tab = event.target
        const tabId = tab.id

        // Update the URL hash
        window.location.hash = tabId.replace(/-tab$/, '')
    }

    function handleTabShown(event) {
        const tab = event.target
        const tabId = tab.id

        resizeMecCalendar(tabId)
    }

    function handleStudyViewsTabShow(event) {
        if (event.target.id !== 'studies-tab') {
            return
        }

        if (
            typeof FWP === 'undefined' ||
            !Array.isArray(FWP.facets?.network) ||
            !FWP.facets.network.length
        ) {
            return
        }

        FWP.reset('network')
    }

    function handleOffcanvasToggle(event) {
        $body.toggleClass('offcanvas-open')
    }

    /**
     * Monitor hash changes and switch to the appropriate tab
     */
    function monitorHashChanges() {
        // Initial window load
        const hash = window.location.hash.slice(1)
        if (hash) {
            switchToTab(`${hash}-tab`)
        }

        // Subsequent hash changes
        window.addEventListener('hashchange', () => {
            const hash = window.location.hash.slice(1)
            if (hash) {
                switchToTab(`${hash}-tab`)
            }
        })
    }

    function resizeMecCalendar(tabId) {
        if (tabId === 'events-tab') {
            mec_wrap_resize?.()
        }
    }

    /**
     * Set up AJAX archive filters (category, search, sortby)
     * @param {HTMLElement} filter The archive filters container
     */
    function setupArchiveFilters(filter) {
        const postType = filter.dataset.postType || 'post'
        const taxonomy = filter.dataset.taxonomy || 'category'
        let categories = filter.dataset.categories || ''

        const categoryFilters = filter.querySelectorAll(
            '.archive-category-link[data-category]'
        )
        const postTypeFilter = filter.querySelectorAll(
            '.archive-post-type-link[data-post-type]'
        )
        const searchForm = filter.querySelector('.search-form')
        const sortbyFilter = filter.querySelectorAll(
            '.archive-sort .dropdown-item[data-orderby][data-order]'
        )
        const postContainer = filter.parentElement.querySelector('.post-list')
        const paginationContainer =
            filter.parentElement.querySelector('.post-pagination')

        if (!postContainer) {
            return
        }

        const triggerAjaxFilter = () => {
            // Add loading state
            filter.classList.add('loading')
            postContainer.classList.add('loading')

            const search = filter.querySelector(
                '.search-form input[type="search"]'
            ).value

            const orderby = filter
                .querySelector('.archive-sort .dropdown-item.disabled')
                ?.getAttribute('data-orderby')

            const order = filter
                .querySelector('.archive-sort .dropdown-item.disabled')
                ?.getAttribute('data-order')

            const selectedCategory = filter
                .querySelector('.archive-category-link[data-category].active')
                ?.getAttribute('data-category')

            const selectedPostType = filter
                .querySelector('.archive-post-type-link[data-post-type].active')
                ?.getAttribute('data-post-type')

            const activePageItem = paginationContainer.querySelector(
                '.page-item.active.pending'
            )
            const activePageLink = activePageItem?.querySelector('.page-link')

            let pageNumber
            if (activePageLink) {
                // Find the page number, either in query string (?paged=X) or in the URL path (/page/X/)
                pageNumber = new URLSearchParams(
                    activePageLink?.href.split('?').pop()
                ).get('paged')
                if (!pageNumber) {
                    pageNumber = activePageLink
                        ?.getAttribute('href')
                        .split('/')
                        .filter(Boolean)
                        .pop()
                }
            }

            const postsPerPage = paginationContainer.dataset.postsPerPage || -1

            const data = {
                action: 'filter_posts',
                post_type: selectedPostType || postType,
                taxonomy: taxonomy,
                category: selectedCategory || categories,
                search: search,
                orderby: orderby,
                order: order,
                paged: pageNumber,
                posts_per_page: postsPerPage,
                path: window.location.pathname,
                nonce: Theme_Variables.nonce,
            }

            $.post(Theme_Variables.ajax_url, data, handleAjaxFilterResponse)
                .fail((response) => {
                    console.error(response)
                })
                .always(() => {
                    // Remove loading state
                    filter.classList.remove('loading')
                    postContainer.classList.remove('loading')
                })
        }

        const handleAjaxFilterResponse = (response) => {
            if (!response.success) {
                console.error(response)
                return
            }

            const posts = response.data?.posts
            const pagination = response.data?.pagination

            if (posts) {
                postContainer.innerHTML = posts
            }

            // Update pagination, even if it's empty
            paginationContainer.innerHTML = pagination

            // Re-attach event listeners to the new pagination links
            const paginationLinks =
                paginationContainer.querySelectorAll('a.page-link')
            paginationLinks.forEach((link) => {
                link.addEventListener('click', onPaginationLinkClick)
            })
        }

        const onCategoryFilterClick = (event) => {
            const thisCategory = event.currentTarget
            const isActive = thisCategory.classList.contains('active')
            categoryFilters.forEach((categoryFilter) => {
                categoryFilter.classList.remove('active')
                categoryFilter.setAttribute('aria-pressed', 'false')
            })
            if (!isActive) {
                thisCategory.classList.add('active')
                thisCategory.setAttribute('aria-pressed', 'true')
            }
            triggerAjaxFilter()
        }

        const onPostTypeFilterClick = (event) => {
            const thisPostType = event.currentTarget
            const isActive = thisPostType.classList.contains('active')
            postTypeFilter.forEach((postTypeFilter) => {
                postTypeFilter.classList.remove('active')
                postTypeFilter.setAttribute('aria-pressed', 'false')
            })
            if (!isActive) {
                thisPostType.classList.add('active')
                thisPostType.setAttribute('aria-pressed', 'true')
            }
            triggerAjaxFilter()
        }

        const onSearchFormSubmit = (event) => {
            event.preventDefault()
            triggerAjaxFilter()
        }

        const onSortFilterClick = (event) => {
            const thisSort = event.currentTarget
            sortbyFilter.forEach((sortFilter) => {
                sortFilter.classList.remove('disabled')
            })
            thisSort.classList.add('disabled')

            const dropdownToggle = thisSort
                .closest('.archive-sort')
                .querySelector('.dropdown-toggle')

            // Check if not default sortby
            if (
                thisSort.getAttribute('data-order') &&
                thisSort.getAttribute('data-orderby')
            ) {
                // Colonit the text and add the filter name
                const small = dropdownToggle.querySelector('small')
                if (small) {
                    small.textContent = thisSort.textContent.trim()
                } else {
                    dropdownToggle.textContent =
                        colonit(dropdownToggle.textContent.trim()) + ' '
                    const small = document.createElement('small')
                    small.textContent = thisSort.textContent.trim()
                    dropdownToggle.appendChild(small)
                }
            } else {
                // Remove the filter name and uncolonit the text
                const small = dropdownToggle.querySelector('small')
                small?.remove()
                dropdownToggle.textContent = uncolonit(
                    dropdownToggle.textContent.trim()
                )
            }
            triggerAjaxFilter()
        }

        const onPaginationLinkClick = (event) => {
            event.preventDefault()
            const pageLink = event.currentTarget
            const pageItem = pageLink.closest('.page-item')
            const pageItems = paginationContainer.querySelectorAll('.page-item')

            // Toggle active class on the parent item
            pageItems.forEach((item) => {
                item.classList.remove('active')
            })
            pageItem.classList.add('active', 'pending')

            // Now we can trigger the ajax filter
            triggerAjaxFilter()
        }

        // Category Filters
        categoryFilters.forEach((categoryFilter) => {
            categoryFilter.addEventListener('click', onCategoryFilterClick)
        })

        // Post type Filters
        postTypeFilter.forEach((postTypeFilter) => {
            postTypeFilter.addEventListener('click', onPostTypeFilterClick)
        })

        // Search Form
        searchForm.addEventListener('submit', onSearchFormSubmit)

        // Sort Filters
        sortbyFilter.forEach((sortFilter) => {
            sortFilter.addEventListener('click', onSortFilterClick)
        })

        // Pagination
        const paginationLinks =
            paginationContainer.querySelectorAll('a.page-link')
        paginationLinks.forEach((link) => {
            link.addEventListener('click', onPaginationLinkClick)
        })
    }

    /**
     * Appends a trailing colon.
     *
     * @param {string} str Value to which trailing colon will be added.
     * @return {string} String with trailing colon added.
     */
    function colonit(str) {
        return uncolonit(str) + ':'
    }

    /**
     * Removes trailing colon if they exist.
     *
     * @param {string} str Value from which trailing colon will be removed.
     * @return {string} String without the trailing colon.
     */
    function uncolonit(str) {
        return str.replace(/:$/, '')
    }

    /**
     * Set up the copy to clipboard button
     *
     * @param {HTMLElement} button
     */
    function setupCopyToClipboardButton(button) {
        button.addEventListener('click', onCopyToClipboardClick)
    }

    /**
     * Handle the copy to clipboard button click
     *
     * @param {Event} event - The click event
     * @returns {Promise} - A promise that resolves when the text has been copied
     */
    function onCopyToClipboardClick(event) {
        const button = event.currentTarget
        const text = button.dataset.clipboardText || button.textContent
        copyToClipboard(text).then(
            () => {
                button.classList.add('copied')
                button.setAttribute('disabled', '')
            },
            (error) => {
                console.warn('Could not copy text to clipboard', error)
            }
        )
    }

    /**
     * Copy the given string to the clipboard
     * @param {string} str - The string to copy
     * @returns {Promise} - A promise that resolves when the string has been copied
     */
    function copyToClipboard(str) {
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            return navigator.clipboard.writeText(str)
        }
        return copyToClipboardLegacy(str)
    }

    /**
     * Copy the given string to the clipboard (legacy)
     * @param {string} str - The string to copy
     * @returns {Promise} - A promise that resolves when the string has been copied
     */
    function copyToClipboardLegacy(str) {
        const el = document.createElement('textarea')
        el.value = str
        el.setAttribute('readonly', '')
        el.style.position = 'absolute'
        el.style.left = '-9999px'
        document.body.appendChild(el)
        el.select()
        // el.setSelectionRange(0, str.length);
        const success = document.execCommand('copy')
        document.body.removeChild(el)
        if (success) {
            return Promise.resolve()
        }
        return Promise.reject('Could not execute "copy" comand')
    }

    /**
     * A11y fixes for Ultimate Member toggle password button
     * @param {HTMLElement} button
     */
    function setupUMTogglePasswordButtonA11y(button) {
        button.setAttribute('role', 'button')
        button.setAttribute('tabindex', '0')
        button.setAttribute('aria-pressed', 'false')
        button.setAttribute('aria-label', __('Show password', 'ccb'))

        const icon = button.querySelector('i')
        icon?.setAttribute('aria-hidden', 'true')

        button.addEventListener('click', function (event) {
            const pressed = button.getAttribute('aria-pressed') === 'true'
            button.setAttribute('aria-pressed', !pressed)
        })

        button.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                button.click()
            }
        })
    }

    /**
     * Toggle the disabled state of WPForms conditional fields
     *
     * @param {Event} event
     * @param {string} formID
     * @param {string} fieldID
     * @param {boolean} pass
     * @param {string} action
     */
    function toggleWPFormsDisabledFields(event, formID, fieldID, pass, action) {
        // Only act on conditional-disabled fields
        const field = document.querySelector(
            `.wpforms-field[data-field-id="${fieldID}"]`
        )
        if (!field.classList.contains('wpforms-conditional-disabled')) {
            return
        }

        const inputs = field.querySelectorAll('input, select, textarea')

        if ((pass && action === 'hide') || (!pass && action !== 'hide')) {
            inputs.forEach((input) => {
                input.disabled = true
            })
        } else {
            inputs.forEach((input) => {
                input.disabled = false
            })
        }
    }

    /**
     * Replace WPForms placeholders with the actual field
     *
     * @param {HTMLElement} placeholder
     */
    function replaceWPFormsPlaceholders(placeholder) {
        const targetID = placeholder.querySelector('input')?.value
        const targetField = document.querySelector(
            `.wpforms-field[data-field-id="${targetID}"]`
        )
        const placeholderWrapper = placeholder.parentElement

        if (!targetField) {
            return
        }

        placeholderWrapper.appendChild(targetField)
    }

    /**
     * Fix WPForms repeater fields positioning inside layouts
     *
     * @param {Event} event
     * @param {JQuery} $clone
     * @param {JQuery} $repeaterField
     */
    function fixWPFormsRepeaterPositioning(event, $clone, $repeaterField) {
        const $triggerButton = $(event.target.activeElement)
        const $currentCloneWrap = $triggerButton.closest(
            '.wpforms-field-repeater-clone-wrap'
        )

        if ($currentCloneWrap.length) {
            // Insert it after the current clone
            $clone.insertAfter($currentCloneWrap)
        } else if ($triggerButton.data('action') === 'addRow') {
            // Insert it at the end
            const $lastClone = $repeaterField.find(
                '.wpforms-field-repeater-clone-wrap:last-child'
            )
            if ($lastClone.length) {
                $clone.insertAfter($lastClone)
            } else {
                $clone.insertAfter(
                    $repeaterField.find(
                        '> .wpforms-field-repeater-display-blocks-buttons'
                    )
                )
            }
        } else {
            // Insert it after the buttons
            const $blockButtons = $repeaterField.find(
                '> .wpforms-field-repeater-display-blocks-buttons'
            )
            $clone.insertAfter($blockButtons)
        }
    }

    /**
     * Update placeholder dynamically (e.g. 6, 9, 12...) for each repeater row created
     * @param {Event} event
     * @param {JQuery} $clone
     * @param {JQuery} $repeaterField
     */
    function updateDynamicNumberPlaceholder(event, $clone, $repeaterField) {
        // Only on the follow-up repeater field
        if ($repeaterField.data('field-id') !== 56) {
            return
        }

        const $clones = $repeaterField.find(
            '.wpforms-field-repeater-clone-wrap'
        )
        $clones.each((index, clone) => {
            const $numberField = $(clone).find('.wpforms-field-number input')
            $numberField.attr('placeholder', `e.g. ${3 + (index + 1) * 3}`)
        })
    }

    /**
     * Update label dynamically (e.g. 1, 2, 3...) for each timepoint row
     * @param {Event} event
     * @param {JQuery} $clone
     * @param {JQuery} $repeaterField
     */
    function updateDynamicTimepointLabel(event, $clone, $repeaterField) {
        // Only on the follow-up repeater field
        if ($repeaterField.data('field-id') !== 56) {
            return
        }

        const $clones = $repeaterField.find(
            '.wpforms-field-repeater-clone-wrap'
        )
        $clones.each((index, clone) => {
            const $timepointLabel = $(clone).find(
                '.wpforms-layout-column:first-child .wpforms-field-label'
            )
            $timepointLabel.text(__('Timepoint', 'ccb') + ' ' + (index + 2))
        })
    }

    /**
     * Setup buttons to add new funders or select existing ones
     */
    function setupFunderButtons() {
        const addButton = document.getElementById('addNewFunder')
        const discardButton = document.getElementById('discardFunder')
        const saveButton = document.getElementById('saveFunder')
        const newFunderWrapper = document.querySelector(
            '.wpforms-field[data-field-id="75"]'
        )
        const funderFieldIdMap = {
            post_title: 76,
            field_67079b1984127: 135, // abbreviation
            field_66ffa8877ff40: 77, // national_international
            field_67079b8384128: 136, // type
            field_66ffaaee7ff41: 78, // country
            field_66ffab5e7ff42: 79, // website
        }

        const onAddNewFunder = (event) => {
            event.preventDefault()

            const input = addButton
                .closest('.wpforms-field-layout')
                .querySelector('.wpf-conditional-funder > input')

            input.value = 1
            $(input).trigger('change')
        }

        const onDiscardFunder = (event) => {
            event.preventDefault()

            const input = discardButton
                .closest('.wpforms-page')
                .querySelector('.wpf-conditional-funder > input')

            input.value = 0
            $(input).trigger('change')
        }

        const onSaveFunder = (event) => {
            event.preventDefault()

            // Prevent multiple clicks while loading
            if (saveButton.classList.contains('loading')) {
                return
            }

            const funderName = newFunderWrapper.querySelector(
                '.wpforms-field[data-field-id="76"] input'
            )?.value

            if (!funderName) {
                alert(__("Please enter the funder's name.", 'ccb'))
                return
            }

            // Add loading state
            saveButton.classList.add('loading')

            const input = saveButton
                .closest('.wpforms-page')
                .querySelector('.wpf-conditional-funder > input')

            const data = {
                action: 'create_new_funder',
                _ajax_nonce: Theme_Variables.nonce,
                funder: {
                    post_title: newFunderWrapper.querySelector(
                        '.wpforms-field[data-field-id="76"] input'
                    )?.value, // Funder's name
                    post_status: 'pending', // Pending review
                    acf: {
                        field_67079b1984127: newFunderWrapper.querySelector(
                            '.wpforms-field[data-field-id="135"] input'
                        )?.value, // Abbreviation
                        field_66ffa8877ff40: newFunderWrapper.querySelector(
                            '.wpforms-field[data-field-id="77"] input:checked'
                        )?.value, // National / international
                        field_67079b8384128: newFunderWrapper.querySelector(
                            '.wpforms-field[data-field-id="136"] input:checked'
                        )?.value, // Type
                        field_66ffaaee7ff41: newFunderWrapper.querySelector(
                            '.wpforms-field[data-field-id="78"] select'
                        )?.value, // Country
                        field_66ffab5e7ff42: newFunderWrapper.querySelector(
                            '.wpforms-field[data-field-id="79"] input'
                        )?.value, // Website
                    },
                },
            }

            $.post(Theme_Variables.ajax_url, data, (response) => {
                if (!response.success) {
                    console.error(response)
                    return
                }

                const funder_id = response.data.post_id
                const $select = $('#wpforms-1009-field_73')
                const selected = $select.val() || []
                const choicesjs = $select.data('choicesjs')

                if (!selected.includes(funder_id)) {
                    choicesjs.setValue([
                        {
                            value: funder_id,
                            label: data.funder.post_title,
                        },
                    ])
                }

                input.value = 0
                $(input).trigger('change')
            })
                .fail((response) => {
                    console.error(response)
                })
                .always(() => {
                    // Remove loading state
                    saveButton.classList.remove('loading')
                })
        }

        addButton?.addEventListener('click', onAddNewFunder)
        discardButton?.addEventListener('click', onDiscardFunder)
        saveButton?.addEventListener('click', onSaveFunder)
    }

    /**
     * Setup custom buttons to add new rows to repeater fields
     */
    function setupAddRowButton() {
        const addButton = document.querySelectorAll(
            'button[data-action="addRow"]'
        )

        addButton.forEach((button) => {
            button.addEventListener('click', function (event) {
                event.preventDefault()

                const repeaterField = document.querySelector(
                    `.wpforms-field[data-field-id='${button.dataset.fieldId}']`
                )
                const lastCloneWrap = repeaterField?.querySelector(
                    '.wpforms-field-repeater-clone-wrap:last-child'
                )

                let lastAddButton = lastCloneWrap?.querySelector(
                    '.wpforms-field-repeater-button-add'
                )

                if (!lastAddButton) {
                    lastAddButton = repeaterField?.querySelector(
                        '.wpforms-field-repeater-button-add'
                    )
                }

                // Delegate the click event to the WPForms default add button
                lastAddButton?.click()
            })
        })
    }

    /**
     * Reposition the save draft button to the left panel of the CDR form
     * @param {HTMLElement} button The save draft button
     */
    function repositionSaveDraftButton(button) {
        if (!button) {
            return
        }

        const form = button.closest('.wpforms-form')
        const leftPanel = form?.querySelector('.wpforms-page-indicator')
        leftPanel?.appendChild(button)
    }

    /**
     * Prevent accidental form exit by showing a confirmation dialog
     */
    function preventAccidentalFormExit() {
        const forms = document.querySelectorAll('.wpforms-form')

        if (!forms.length) {
            return
        }

        let isSubmitting = false
        forms.forEach((form) => {
            form.addEventListener('submit', function (event) {
                isSubmitting = true
            })
        })

        window.addEventListener('beforeunload', function (e) {
            if (isSubmitting) {
                return
            }

            const confirmationMessage = __(
                "Are you sure you want to exit? You can save a draft and resume later by clicking the 'Save draft' button at the left panel.",
                'ccb'
            )

            ;(e || window.event).returnValue = confirmationMessage

            return confirmationMessage
        })
    }

    function initializeWPFormsSelect2Fields(selects) {
        if (!selects.length) {
            return
        }

        selects.forEach((select) => {
            const $select = $(select)
            const placeholder = $select.find('option.placeholder').text()

            // Remove the placeholder from the options (already handled by select2)
            $select.find('option.placeholder').remove()

            const options = {
                width: '100%',
                tags: true, // Allow user to add new options
                tokenSeparators: [','],
                allowClear: true,
                placeholder: placeholder,
                dropdownCssClass: `select2-dropdown--field-${$select.closest('.wpforms-field').data('field-id')}`,
            }

            $select.select2(options)

            $(window).on('load', () => {
                // Double check if the select2 field is initialized (Safari bug)
                if (!$select.hasClass('select2-hidden-accessible')) {
                    $select.select2(options)
                }
            })

            // Add event listeners
            addSelect2EventListeners(select)
        })
    }

    function addSelect2EventListeners(select) {
        const $select = $(select)

        const onlyShowDropdownWhenTyping = function () {
            const $searchField = $select
                .next('.select2-container')
                .find('.select2-search__field')

            // Check if the search field belongs to a dynamic taxonomy field
            const fieldID = $select.closest('.wpforms-field').data('field-id')
            const taxonomy = Object.entries(
                Theme_Variables.wpf_taxonomies_fields_map
            ).find(([_taxonomy, _fieldID]) => _fieldID === fieldID)?.[0]

            if (!taxonomy) {
                return
            }

            let isTyping = false

            $searchField.on('input', (e) => {
                const $dropdown = $(`#${$searchField.attr('aria-controls')}`)
                const $dropdownContainer =
                    $dropdown.closest('.select2-container')

                isTyping = !!$searchField.val()
                $dropdownContainer.toggle(isTyping)
            })

            $select.on('select2:open', (e) => {
                const $dropdown = $(`#${$searchField.attr('aria-controls')}`)
                const $dropdownContainer =
                    $dropdown.closest('.select2-container')

                $dropdownContainer.toggle(isTyping)
            })
        }

        // Only show dropdown when typing, not when clicking for the first time on the field
        onlyShowDropdownWhenTyping()
    }

    function initializeWPFormsTaxonomyTagCloud() {
        const tags = document.querySelectorAll(
            '.wpforms-form .study-descriptors-tag-cloud button'
        )

        if (!tags.length) {
            return
        }

        const onclickWPFormsTag = (event) => {
            event.preventDefault()

            const tag = event.currentTarget
            const tagWrapper = tag.closest('.tag')
            const taxonomy = tag.dataset.taxonomy
            const term = tag.dataset.term
            const fieldID = Theme_Variables.wpf_taxonomies_fields_map[taxonomy]
            const $select = $(
                `.wpforms-field[data-field-id="${fieldID}"] select`
            )
            const selected = $select.val() || []

            if (!selected.includes(term)) {
                selected.push(term)
                $select.val(selected).trigger('change')
                tagWrapper.hidden = true
            }
        }

        tags.forEach((tag) => {
            tag.addEventListener('click', onclickWPFormsTag)
        })

        // Toggle visibility of the tags when the select2 field changes
        $(document).on(
            'change',
            '.wpforms-form .select2 select',
            function (event) {
                const $select = $(event.currentTarget)
                const fieldID = $select
                    .closest('.wpforms-field')
                    .data('field-id')
                const taxonomy =
                    Object.entries(
                        Theme_Variables.wpf_taxonomies_fields_map
                    ).find(
                        ([_taxonomy, _fieldID]) => _fieldID === fieldID
                    )?.[0] || ''

                if (!taxonomy) {
                    return
                }

                const tags = document.querySelectorAll(
                    `.wpforms-form .study-descriptors-tag-cloud button[data-taxonomy="${taxonomy}"]`
                )
                const selected = $select.val() || []

                tags.forEach((tag) => {
                    const term = tag.dataset.term
                    const tagWrapper = tag.closest('.tag')
                    if (selected.includes(term)) {
                        tagWrapper.hidden = true
                    } else {
                        tagWrapper.hidden = false
                    }
                })
            }
        )
    }

    function initializeWPFormsSyncedFields(syncedFields) {
        syncedFields.forEach((targetField) => {
            const targetFieldInput = targetField.querySelector(
                'input, select, textarea'
            )
            const sourceId = targetField.className.match(/wpf-sync--(\d+)/)?.[1]

            if (!sourceId) {
                return
            }

            const sourceField = document.querySelector(
                `.wpforms-field[data-field-id="${sourceId}"] :where(input, select, textarea)`
            )

            if (!sourceField) {
                return
            }

            sourceField.addEventListener('input', (event) => {
                targetFieldInput.value = transformSyncedField(
                    event,
                    targetFieldInput,
                    sourceId
                )
            })
        })
    }

    function setMinMaxAttributesForWPFormsNumberFields() {
        const positiveNumbers = document.querySelectorAll(
            '.wpf-number-positive input[type="number"]'
        )

        positiveNumbers.forEach((input) => {
            input.setAttribute('min', 0)
        })
    }

    function transformSyncedField(event, field, sourceId) {
        let transformedValue = event.target.value

        const sanitizeUsername = (str) => {
            return str.replace(/[^a-zA-Z0-9]/g, '')
        }

        if (sourceId == 3) {
            // Transform email to username (removing special characters for auto-login to work).
            // transformedValue = sanitizeUsername(transformedValue)
        }

        return transformedValue
    }

    /**
     * Initialize the follow-up repeater field
     * @param {HTMLElement} repeaterField
     */
    function initializeFollowupRepeaterField() {
        const $repeaterField = $('.wpforms-field[data-field-id="56"]')

        if (!$repeaterField.length) {
            return
        }

        const $addButton = $repeaterField.find(
            '.wpforms-field-repeater-button-add'
        )
        const $clones = $repeaterField.find(
            '.wpforms-field-repeater-clone-wrap'
        )

        if (!$clones.length) {
            // Add the first row if there are none
            setTimeout(() => {
                $addButton.trigger('click')
            }, 50)
        }
    }

    /**
     * Initialize conditional tags
     */
    function initializeConditionalTags() {
        const taxonomyConditionalMap = [
            {
                taxonomy: 'biosamples',
                fieldID: 129,
                conditions: ['Yes'],
            },
        ]

        taxonomyConditionalMap.forEach(({ taxonomy, fieldID, conditions }) => {
            const conditionalTags = document.querySelectorAll(
                `.wpforms-form .study-descriptors-tag-cloud .tag button[data-taxonomy="${taxonomy}"]`
            )
            if (!conditionalTags.length) {
                return
            }

            // By default, the tags should be disabled
            conditionalTags.forEach((tag) => {
                tag.disabled = true
            })

            const conditionalField = document.querySelector(
                `.wpforms-field[data-field-id="${fieldID}"]`
            )
            const conditionInputs = conditionalField?.querySelectorAll(
                'input[type="radio"], input[type="checkbox"]'
            )

            const onConditionChange = (event) => {
                const value = event.currentTarget.value
                const checked = event.currentTarget.checked

                conditionalTags.forEach((tag) => {
                    if (checked && conditions.includes(value)) {
                        tag.disabled = false
                        tag.closest('.tag').hidden = false
                    } else {
                        tag.disabled = true
                        tag.closest('.tag').hidden = true
                    }
                })
            }

            conditionInputs?.forEach((condition) => {
                condition.addEventListener('change', onConditionChange)
            })
        })
    }

    /**
     * Set default value for select fields inside conditional repeaters
     *
     * @param {Event} event
     * @param {string} formID
     * @param {string} fieldID
     * @param {boolean} pass
     * @param {string} action
     */
    function setDefaultSelectValueFollowupField(
        event,
        formID,
        fieldID,
        pass,
        action
    ) {
        const followupFieldID = '56'
        if (fieldID !== followupFieldID) {
            return
        }

        const $repeaterField = $(`.wpforms-field[data-field-id="${fieldID}"]`)
        const $select = $repeaterField.find('.wpforms-field-select select')

        if ((pass && action === 'show') || (!pass && action !== 'show')) {
            $select
                .val($select.find('option[selected]').val())
                .trigger('change')
        }
    }

    function setDefaultMapPosition() {
        FWP.hooks.addFilter('facetwp_map/fit_bounds', function (fit_bounds) {
            return FWP.loaded // force the custom lat/lng/zoom only on initial page load
        })
    }

    function initializeOrUpdateMapData() {
        if (!FWP.loaded) {
            // First time loading. Initialize the Eurostat-map
            const map = eurostatmap
                .map('proportionalSymbol')
                .width(900)
                .height(700)
                .nutsLevel(0)
                .nutsYear(2021)
                // .zoomExtent([0.1, 1])
                // .proj('3035')
                // .position({ x: 5240000, y: 3350000, z: 6044 })
                .nutsrgFillStyle('#005B81')
                .psMinSize(8)
                .psMaxSize(22)
                .psFill('#BFF5FF')
                .psFillOpacity(0.9)
                .psStroke('rgba(191, 245, 255, 0.5)')
                .psStrokeWidth(12)
                .hoverColor('#80ebff')
                .noDataFillStyle('#BAC8CF')
                .labels({
                    values: true, // label statistical values directly
                    backgrounds: true, // for better legibility of labelled values
                    shadows: true,
                })
                .dorling(false)
                .footnoteTooltipText(null)

            translateTooltipText(map)

            window.studiesMap = map

            // Wait for FacetWP to finish loading
            setTimeout(() => {
                map.statData()
                    .unitText(__('studies', 'ccb'))
                    .setData(getMapData())
                map.build()

                // Add a responsive viewBox to the generated SVG so the map scales correctly
                const svgNode = map.svg().node()
                if (svgNode) {
                    const bbox = svgNode.getBBox ? svgNode.getBBox() : null
                    const width =
                        svgNode.getAttribute('width') ||
                        (bbox ? bbox.width : svgNode.clientWidth) ||
                        795
                    const height =
                        svgNode.getAttribute('height') ||
                        (bbox ? bbox.height : svgNode.clientHeight) ||
                        700
                    svgNode.setAttribute('viewBox', `0 0 ${width} ${height}`)
                }
            }, 0)

            // Scale the font size labels on every map update
            map.callback(scaleLabelsFontSize)

            // Save the map instance for subsequent loading
            document.getElementById('eurostat-map').eurostatmap = map
        } else {
            // Subsequent loading. Update the map data
            const map = document.getElementById('eurostat-map').eurostatmap

            // Wait for FacetWP to finish loading
            setTimeout(() => {
                map?.statData().setData(getMapData())
                map?.updateStatValues()
                scaleLabelsFontSize(map)
            }, 0)
        }
    }

    function updateSitesList() {
        const sitesList = document.querySelector('.studies-list--sites')
        const paginationContainer = document.querySelector('.sites-pagination')

        if (!sitesList || !paginationContainer) {
            console.warn('[sites] updateSitesList aborted: missing DOM nodes')
            return
        }

        const data = !FWP.loaded
            ? FWP_JSON?.preload_data?.template
            : FWP.response?.template_sites || FWP.response?.template || ''

        sitesList.innerHTML = data || ''
        paginationContainer.dataset.currentPage = '1'

        setupSitesPagination()
    }

    function cacheStudyResultsCount() {
        const facetCountEl = document.querySelector(
            '.facetwp-facet-results_count'
        )
        if (facetCountEl) {
            facetCountEl.dataset.studyCount = facetCountEl.textContent
            const studyTotal = parseResultsCount(facetCountEl.textContent)

            if (studyTotal !== null) {
                updateTabCount('studies-tab', studyTotal)
            }
        }
    }

    function getSiteFacetCounts() {
        return FWP.loaded
            ? FWP.response?.site_facet_counts || {}
            : FWP_JSON?.preload_data?.site_facet_counts || {}
    }

    function applySiteFacetCounters() {
        if (!document.querySelector('#sites-tab.active')) {
            return
        }

        const siteFacetCounts = getSiteFacetCounts()

        document
            .querySelectorAll('.facetwp-facet[data-name]')
            .forEach((facet) => {
                const counts = siteFacetCounts[facet.dataset.name]
                if (!counts) {
                    return
                }

                facet
                    .querySelectorAll('.facetwp-counter')
                    .forEach((counter) => {
                        const choice = counter.closest('[data-value]')
                        const value = choice?.dataset.value
                        if (
                            value === undefined ||
                            counts[value] === undefined
                        ) {
                            return
                        }

                        if (counter.dataset.studyCounter === undefined) {
                            counter.dataset.studyCounter = counter.textContent
                        }

                        if (choice.dataset.studyDisabled === undefined) {
                            choice.dataset.studyDisabled = choice.classList.contains(
                                'disabled'
                            )
                                ? 'true'
                                : 'false'
                        }

                        const siteCount = Number.parseInt(counts[value], 10)
                        counter.textContent = `(${counts[value]})`
                        choice.classList.toggle('disabled', siteCount === 0)
                    })
            })
    }

    function restoreStudyFacetCounters() {
        document.querySelectorAll('.facetwp-counter').forEach((counter) => {
            if (counter.dataset.studyCounter !== undefined) {
                counter.textContent = counter.dataset.studyCounter
            }

            const choice = counter.closest('[data-value]')
            if (choice?.dataset.studyDisabled !== undefined) {
                choice.classList.toggle(
                    'disabled',
                    choice.dataset.studyDisabled === 'true'
                )
                delete choice.dataset.studyDisabled
            }
        })
    }

    function parseResultsCount(value) {
        const matches = String(value).match(/[\d,]+/g)

        if (!matches?.length) {
            return null
        }

        return Number.parseInt(
            matches[matches.length - 1].replace(/,/g, ''),
            10
        )
    }

    function updateTabCount(tabId, total) {
        const tab = document.getElementById(tabId)

        if (!tab) {
            return
        }

        if (!tab.dataset.label) {
            tab.dataset.label = tab.textContent.trim()
        }

        tab.textContent = `${tab.dataset.label} (${total})`
    }

    /**
     * Update the sites list header with the current total results.
     *
     * @param {CustomEvent} event
     */
    function updateSitesResultsCount(event) {
        const countEl = document.querySelector('.sites-list-results-count')
        const facetCountEl = document.querySelector(
            '.facetwp-facet-results_count'
        )
        if (!countEl && !facetCountEl) {
            return
        }

        const totalSites = event?.detail?.totalSites ?? 0
        const currentPage = event?.detail?.currentPage ?? 1
        const pageSize = event?.detail?.pageSize ?? 24
        updateTabCount('sites-tab', totalSites)
        const resultsLabel = _n('result', 'results', totalSites, 'ccb')
        const totalResultsText = `${totalSites} ${resultsLabel}`
        const firstResult = totalSites ? (currentPage - 1) * pageSize + 1 : 0
        const lastResult = Math.min(currentPage * pageSize, totalSites)
        const resultsText = totalSites
            ? `${firstResult}-${lastResult} of ${totalSites} ${resultsLabel}`
            : `0 ${resultsLabel}`

        if (countEl) {
            countEl.textContent = ` (${totalResultsText})`
        }

        if (facetCountEl && document.querySelector('#sites-tab.active')) {
            if (!facetCountEl.dataset.studyCount) {
                facetCountEl.dataset.studyCount = facetCountEl.textContent
            }

            facetCountEl.dataset.sitesCount = resultsText
            facetCountEl.textContent = facetCountEl.dataset.sitesCount
        }

        applySiteFacetCounters()
    }

    function updateResultsCountForActiveView(event) {
        const facetCountEl = document.querySelector(
            '.facetwp-facet-results_count'
        )
        if (!facetCountEl) {
            return
        }

        if (event.target.id === 'sites-tab') {
            setupSitesPagination()
            return
        }

        restoreStudyFacetCounters()
        if (facetCountEl.dataset.studyCount) {
            facetCountEl.textContent = facetCountEl.dataset.studyCount
        }
    }

    /**
     * Set up client-side pagination for the sites list.
     *
     * The full filtered sites set stays in the DOM so the map can consume it.
     */
    function setupSitesPagination() {
        const sitesList = document.querySelector('.studies-list--sites')
        const paginationContainer = document.querySelector('.sites-pagination')

        if (!sitesList || !paginationContainer) {
            console.warn(
                '[sites] setupSitesPagination aborted: missing DOM nodes'
            )
            return
        }

        const items = getSitesListItems(sitesList)
        const postsPerPage = parseInt(
            paginationContainer.dataset.postsPerPage,
            10
        )
        const pageSize =
            Number.isFinite(postsPerPage) && postsPerPage > 0
                ? postsPerPage
                : 24

        if (!items.length) {
            paginationContainer.innerHTML = ''
            paginationContainer.hidden = true
            paginationContainer.dataset.totalPages = '1'
            paginationContainer.dataset.currentPage = '1'
            console.warn('[sites] no article items found to paginate')

            document.dispatchEvent(
                new CustomEvent('ccb-sites-list-updated', {
                    detail: {
                        totalSites: 0,
                        currentPage: 1,
                        totalPages: 1,
                        pageSize,
                    },
                })
            )
            return
        }

        paginationContainer.hidden = false

        const totalPages = Math.max(1, Math.ceil(items.length / pageSize))
        const currentPage = 1

        paginationContainer.dataset.totalPages = String(totalPages)
        paginationContainer.dataset.currentPage = String(currentPage)

        if (!paginationContainer.dataset.bound) {
            paginationContainer.addEventListener(
                'click',
                onSitesPaginationClick
            )
            paginationContainer.dataset.bound = 'true'
        }

        if (totalPages === 1) {
            paginationContainer.innerHTML = ''
            showSitesPage(items, 1, pageSize)
        } else {
            renderSitesPagination(paginationContainer, currentPage, totalPages)
            showSitesPage(items, currentPage, pageSize)
        }

        document.dispatchEvent(
            new CustomEvent('ccb-sites-list-updated', {
                detail: {
                    totalSites: items.length,
                    currentPage,
                    totalPages,
                    pageSize,
                },
            })
        )
    }

    /**
     * Get the direct article children from the sites list wrapper.
     *
     * @param {HTMLElement} sitesList
     * @returns {HTMLElement[]}
     */
    function getSitesListItems(sitesList) {
        return Array.from(sitesList.children).filter(
            (child) => child.tagName === 'ARTICLE'
        )
    }

    /**
     * Render the sites pagination controls.
     *
     * @param {HTMLElement} paginationContainer
     * @param {number} currentPage
     * @param {number} totalPages
     */
    function renderSitesPagination(
        paginationContainer,
        currentPage,
        totalPages
    ) {
        const pages = getVisibleSitePages(currentPage, totalPages)
        const controls = []

        controls.push(
            renderSitesPageItem({
                label: __('Previous', 'ccb'),
                page: Math.max(1, currentPage - 1),
                disabled: currentPage === 1,
            })
        )

        pages.forEach((page) => {
            if (page === '...') {
                controls.push(
                    '<li class="page-item disabled" aria-hidden="true"><span class="page-link">&hellip;</span></li>'
                )
                return
            }

            controls.push(
                renderSitesPageItem({
                    label: String(page),
                    page,
                    active: page === currentPage,
                })
            )
        })

        controls.push(
            renderSitesPageItem({
                label: __('Next', 'ccb'),
                page: Math.min(totalPages, currentPage + 1),
                disabled: currentPage === totalPages,
            })
        )

        paginationContainer.innerHTML = `
            <ul class="pagination justify-content-center flex-wrap gap-2 mb-0">
                ${controls.join('')}
            </ul>
        `
    }

    /**
     * Render a single pagination item.
     *
     * @param {Object} options
     * @returns {string}
     */
    function renderSitesPageItem(options) {
        const { label, page, active = false, disabled = false } = options
        const icon =
            label === __('Previous', 'ccb')
                ? '&laquo;'
                : label === __('Next', 'ccb')
                  ? '&raquo;'
                  : label

        return `
            <li class="page-item${active ? ' active' : ''}${disabled ? ' disabled' : ''}">
                <a class="page-link" href="#" data-page="${page}"${active ? ' aria-current="page"' : ''}${disabled ? ' aria-disabled="true" tabindex="-1"' : ''}>${icon}</a>
            </li>
        `
    }

    /**
     * Return a condensed list of pages with ellipses.
     *
     * @param {number} currentPage
     * @param {number} totalPages
     * @returns {Array<number|string>}
     */
    function getVisibleSitePages(currentPage, totalPages) {
        if (totalPages <= 7) {
            return Array.from({ length: totalPages }, (_, index) => index + 1)
        }

        const pages = [1]
        const start = Math.max(2, currentPage - 1)
        const end = Math.min(totalPages - 1, currentPage + 1)

        if (start > 2) {
            pages.push('...')
        }

        for (let page = start; page <= end; page += 1) {
            pages.push(page)
        }

        if (end < totalPages - 1) {
            pages.push('...')
        }

        pages.push(totalPages)

        return pages
    }

    /**
     * Show the current page of sites.
     *
     * @param {HTMLElement[]} items
     * @param {number} currentPage
     * @param {number} pageSize
     */
    function showSitesPage(items, currentPage, pageSize) {
        const start = (currentPage - 1) * pageSize
        const end = start + pageSize

        items.forEach((item, index) => {
            const isVisible = index >= start && index < end
            item.classList.toggle('d-none', !isVisible)
            item.setAttribute('aria-hidden', isVisible ? 'false' : 'true')
        })
    }

    /**
     * Handle clicks on sites pagination.
     *
     * @param {MouseEvent} event
     */
    function onSitesPaginationClick(event) {
        const link = event.target.closest('a.page-link[data-page]')
        if (
            !link ||
            link.closest('.page-item')?.classList.contains('disabled')
        ) {
            return
        }

        event.preventDefault()

        const paginationContainer = link.closest('.sites-pagination')
        const sitesList = document.querySelector('.studies-list--sites')

        if (!paginationContainer || !sitesList) {
            return
        }

        const totalPages =
            parseInt(paginationContainer.dataset.totalPages, 10) || 1
        const currentPage = clampPageNumber(
            parseInt(link.dataset.page, 10) || 1,
            totalPages
        )
        const items = getSitesListItems(sitesList)
        const pageSize =
            parseInt(paginationContainer.dataset.postsPerPage, 10) || 24

        paginationContainer.dataset.currentPage = String(currentPage)
        renderSitesPagination(paginationContainer, currentPage, totalPages)
        showSitesPage(items, currentPage, pageSize)

        document.dispatchEvent(
            new CustomEvent('ccb-sites-list-updated', {
                detail: {
                    totalSites: items.length,
                    currentPage,
                    totalPages,
                    pageSize,
                },
            })
        )
    }

    /**
     * Clamp a page number to the available range.
     *
     * @param {number} pageNumber
     * @param {number} totalPages
     * @returns {number}
     */
    function clampPageNumber(pageNumber, totalPages) {
        return Math.min(Math.max(pageNumber, 1), totalPages)
    }

    /**
     * Get the map data from the FacetWP facets to update the Eurostat map
     * @returns {Object} The map data
     */
    function getMapData() {
        const countryFacet = document.getElementById('facetCollapse-country')

        const countryFacetItems =
            countryFacet?.querySelectorAll('.facetwp-checkbox') || []

        const countryFacetData = Array.from(countryFacetItems).reduce(
            (acc, item) => {
                const country = item.querySelector(
                    '.facetwp-display-value'
                ).textContent

                const count = Number.parseInt(
                    item
                        .querySelector('.facetwp-counter')
                        ?.textContent.replace(/[(),]/g, '')
                        .trim(),
                    10
                )

                if (!Number.isFinite(count) || count < 1) {
                    return acc
                }

                acc[Country_Codes[country] || country] = count

                return acc
            },
            {}
        )

        // Eurostat does not handle empty data, so make sure there is always 1 key at least (even if not valid like "empty").
        return Object.keys(countryFacetData).length
            ? countryFacetData
            : { empty: 1 }
    }

    /**
     * Scale the labels font size proportionally to the symbol size
     * @param {number} minFontSize The minimum font size
     * @param {number} maxFontSize The maximum font size
     */
    function scaleLabelsFontSize(map, minFontSize = 12, maxFontSize = 24) {
        let sizeData = map.statData('size').getArray()
            ? map.statData('size')
            : map.statData()

        let symbolContainers = map
            .svg()
            .selectAll('g.em-centroid')
            .filter((d) => {
                const datum = sizeData.get(d.properties.id)
                return datum?.value !== ':' && datum?.value != null // Ignore `':'`, `null`, and `undefined`
            })

        const textLabels = symbolContainers.selectChild('text')

        const radii = symbolContainers.data().map((d) => {
            const datum = sizeData.get(d.properties.id)
            return datum ? map.classifierSize_(datum.value) : 0
        })

        const minRadius = Math.min(...radii)
        const maxRadius = Math.max(...radii)

        const statLabels = textLabels.style('font-size', (d) => {
            const datum = sizeData.get(d.properties.id)
            const radius = datum ? map.classifierSize_(datum.value) : 0
            const fontSize =
                minFontSize +
                (maxFontSize - minFontSize) *
                    ((radius - minRadius) / (maxRadius - minRadius))

            const validFontSize = Math.max(
                minFontSize,
                Math.min(maxFontSize, isNaN(fontSize) ? minFontSize : fontSize)
            )
            return `${validFontSize}px`
        })
    }

    /**
     * Map the Eurostat official country names to English
     * @param {string} originalCountryName The original country name from the Eurostat data
     * @returns {string} The English country name
     */
    function getEnglishCountryName(originalCountryName) {
        return (
            Eurostat_Country_Names[originalCountryName] ?? originalCountryName
        )
    }

    /**
     * Translate the official country names in the tooltip to English
     * @param {EurostatMap} map The EurostatMap instance
     */
    function translateTooltipText(map) {
        const originalTextFunction = map.tooltip().textFunction

        map.tooltip({
            textFunction: (rg, map) => {
                rg.properties.na = getEnglishCountryName(rg.properties.na)
                return originalTextFunction(rg, map)
            },
        })
    }

    /**
     * Exclude some facets from the FacetWP flyout menu
     * @param {Array} facets - The FacetWP flyout facet list
     * @returns
     */
    const excludeFlyoutFacets = (facets) => {
        const exclude_flyout = ['search', 'reset']
        facets = facets.filter(function (el) {
            return exclude_flyout.indexOf(el) < 0
        })
        return facets
    }

    /**
     * Filter each Flyout facet's wrapper HTML
     * @param {String} facet_html - The FacetWP flyout facet wrapper HTML
     * @returns {String} The filtered HTML
     */
    const filterFlyoutFacetHTML = (facet_html) => {
        const $facet_html = $(facet_html)

        // Extract the facet name
        const facetName = $facet_html
            .attr('class')
            .split(' ')
            .find((className) => className.startsWith('name-'))
            .replace('name-', '')

        $facet_html.addClass('accordion-item facet')

        // Build the accordion headers
        const $facetLabel = $facet_html.children('h3')
        $facetLabel
            .addClass('accordion-header facet-label')
            .attr('id', `flyoutFacetHeading-${facetName}`)
            .wrapInner(
                `<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flyoutFacetCollapse-${facetName}" aria-expanded="false" aria-controls="flyoutFacetCollapse-${facetName}"><span></span></button>`
            )

        // Build the accordion collapse
        const $facetCollapse = $facet_html.children('.flyout-item')
        $facetCollapse
            .addClass(`accordion-collapse accordion-body collapse`)
            .attr('id', `flyoutFacetCollapse-${facetName}`)
            .attr('aria-labelledby', `flyoutFacetHeading-${facetName}`)
        // .wrapInner('<div class="accordion-body"></div>') // This doesn't work because inner content is added dynamically

        return $facet_html.prop('outerHTML')
    }

    /**
     * Make sure the end date is always greater than the start date
     *
     * @param {HTMLElement} startDateEl The start date input element
     * @param {HTMLElement} endDateEl The end date input element
     */
    function validateDatepickerRange(startDateEl, endDateEl) {
        if (!startDateEl || !endDateEl) {
            return
        }

        const endFlatpickr = endDateEl.closest(
            '.wpforms-datepicker-wrap'
        )?._flatpickr

        if (!endFlatpickr) {
            return
        }

        // Listen for the change event on the start date, and update the enddate minDate accordingly
        const onStartDateChange = (event) => {
            const startDate = event.target.value
            endFlatpickr.set('minDate', startDate)
        }

        startDateEl.addEventListener('change', onStartDateChange)
    }
})(jQuery)
